import { Component, computed, input } from '@angular/core'
import { formatNotificationCount } from '../../functions/format-notification-count'

/** Compact overlay count badge with neutral and accent variants. */
@Component({
  selector: 'aw-counter-badge',
  templateUrl: './counter-badge.component.html',
  styleUrl: './counter-badge.component.scss'
})
export class CounterBadgeComponent {
  readonly count = input.required<number>()
  readonly variant = input<'neutral' | 'accent'>('neutral')
  protected readonly label = computed(() => formatNotificationCount(this.count()))
}
